<template>
  <div id="app">
    <hybhead title="产品功能" ></hybhead>
                <div class="page-div"></div>

    <div class="banner"></div>
    <div class="p-btn">
      <div v-show="btnflag"  class="p-btn-left p-btn-active">多种伪装外壳</div>
      <div v-show="btnflag" @click="changeMenu(1)" class="p-btn-right p-btn-unactive">强大的伪装功能</div>

      <div v-show="!btnflag" @click="changeMenu(2)" class="p-btn-left p-btn-unactive">多种伪装外壳</div>
      <div v-show="!btnflag" class="p-btn-right p-btn-active">强大的伪装功能</div>
    </div>

    <div v-show="btnflag" class="content-desc">手机里安装这些APP，完全看不出来是聊天APP哦~ 不同类型的APP之间可以正常交流，毫无障碍</div>

    <div v-show="btnflag" class="app-info">
      <div class="app-info-utils">
        <img src="../assets/img/app-info-utils.png" alt srcset />
        <p>工具类</p>
        <span>
          伪装成计算器、闹钟等工具
          <br />人畜无害的工具
          <br />但消息通知过于频繁，可能引起怀疑
        </span>
      </div>
      <div class="app-info-utils">
        <img src="../assets/img/app-info-news.png" alt srcset />
        <p>新闻类</p>
        <span>
          伪装成新闻、头条等工具
          <br />收到聊天消息时提示新闻热点
          <br />智能伪装，毫无破绽
        </span>
      </div>
    </div>
    <div v-show="btnflag" class="app-info">
      <div class="app-info-utils">
        <img src="../assets/img/app-info-xuexi.png" alt srcset />
        <p>学习类</p>
        <span>
          伪装成学英语、学韩语等工具
          <br />学习聊天秒切换
          <br />展示积极向上的人设
        </span>
      </div>
      <div class="app-info-utils">
        <img src="../assets/img/app-info-youxi.png" alt srcset />
        <p>游戏类</p>
        <span>
          伪装成类似连连看等游戏APP
          <br />防查岗，安全保险
          <br />聊天时遇突发情况，秒切换至游戏页面
        </span>
      </div>
    </div>


    <div v-show="!btnflag" class="content-desc">智能伪装设置，保护隐私安全，防止信息泄露</div>

    <div v-show="!btnflag" v-for="imginfo in imglist" :key="imginfo">
      <div class="app-info-g-list">
        <img :src="imginfo.url" alt />
      </div>
      <div class="app-info-g-list-border"></div>
    </div>
    <hybfoot></hybfoot>
  </div>
</template>
<script>
import hybhead from "../views/common/head";
import hybfoot from "../views/common/foot";


export default {
  metaInfo: {
    title: "私密聊天软件功能说明-好运吧",
    meta:[
      {
        name:'keyWords',
        content:'私密聊天软件功能'
      },
      {
        name:'description',
        content:'好运吧私密聊天软件是一款可以进行伪装不被发现的一对一聊天软件，功能强大，点击查看详情。'
      }
    ]
    
  },
  name: "app",
  data() {
    return {
      msg: "注册协议Index",
      btnflag: true,
      imglist: [
        { url: "/static/img/app-info-g-1.png" },
        { url: "/static/img/app-info-g-2.png" },
        { url: "/static/img/app-info-g-3.png" },
        { url: "/static/img/app-info-g-4.png" },
        { url: "/static/img/app-info-g-5.png" },
        { url: "/static/img/app-info-g-6.png" },
        { url: "/static/img/app-info-g-7.png" },
        { url: "/static/img/app-info-g-8.png" },
        { url: "/static/img/app-info-g-9.png" },
        { url: "/static/img/app-info-g-10.png" }
      ]
    };
  },
  methods: {
    changeMenu(type) {
      if (type == 1) {
        this.btnflag = false;
      } else {
        this.btnflag = true;
      }
    }
  },
  components: {
    hybhead,hybfoot
  }
};
</script>
<style  scoped>
.banner {
  width: 750px;
  height: 1012px;
  background: linear-gradient(90deg, #8a4cff 0%, #4668ff 100%);
  background-image: url("../assets/img/product-banner.png");
  background-size: 100%;
}
.page-div{
  width: 100%;
  height: 100px;
} 
.banner-title-k {
  width: 750px;
  height: 100px;
}
.banner-title {
  width: 750px;
  height: 46px;
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 27px;
  margin: 0 auto 0 auto;
  text-align: center;
}
.banner-text {
  width: 750px;
  height: 25px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  margin: 19px auto 0 auto;
}
.banner-img {
  width: 230px;
  height: 465px;
  margin: 64px auto 0 auto;
}
.banner-img img {
  width: 100%;
  height: 100%;
}



.content {
  width: 100%;
  margin: 99px auto 0 auto;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  line-height: 27px;
}
.content-desc {
  margin: 20px auto 0 auto;
  width: 551px;
  height: 52px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 28px;
}
.app-info {
  width: 95%;
  height: auto;
  display: flex;
  margin: 60px auto 20px auto;
}

.app-info-utils,
.app-info-news {
  flex: 1;
  align-items: center;
  justify-content: center;
}

.app-info-utils img {
  width: 120px;
  height: 120px;
}

.app-info-utils p {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  line-height: 22px;
}
.app-info-utils span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}

.app-info-g-list {
  width: 100%;
  height: 424px;
  margin: 70px auto 70px auto;
}

.app-info-g-list img {
  width: 100%;
  height: 100%;
}
.app-info-g-list-border {
  width: 690px;
  height: 1px;
  background: #eeeeee;
  margin: 0 auto;
}

.p-btn {
  width: 690px;
  height: 90px;
  margin: 90px auto 60px auto;
  display: flex;
  border: 2px solid #1d79f5;
  
}

.p-btn-left {
  flex: 1;
}
.p-btn-right {
  flex: 1;
}
.p-btn-active {
  background: #1d79f5;

  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 90px;
  padding: 0;
  margin: 0;
}

.p-btn-unactive {
  background: #ffffff;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1d79f5;
  line-height: 90px;
}
</style>


// WEBPACK FOOTER //
// src/views/product.vue